import React from 'react'
import { useTheme } from '@opallabs/hooks'
import {
  type ButtonVariantComponent,
  type ButtonVariantProps,
  type PolymorphicRef,
} from './types'
import { useVariantStyle } from './useVariantStyle'

export { type ButtonVariantProps }

/** @private Only for use in stories */
export const DEFAULT_ELEMENT = 'button'

/**
 * Polymorphic component used to apply the styling of Gem's button variants
 * to a <button> or <a> element.
 */
// eslint-disable-next-line react/display-name
export const ButtonVariant: ButtonVariantComponent = React.forwardRef(
  <TElement extends React.ElementType = typeof DEFAULT_ELEMENT>(
    {
      as,
      children,
      className,
      theme: propTheme,
      variant = 'primary',
      ...elementProps
    }: ButtonVariantProps<TElement>,
    ref?: PolymorphicRef<TElement>
  ) => {
    const Component = as ?? DEFAULT_ELEMENT

    const providedTheme = useTheme()
    const theme = propTheme ?? providedTheme
    const style = useVariantStyle(variant)

    return (
      <Component
        css={style[theme]}
        className={className}
        ref={ref}
        {...elementProps}
      >
        {children}
      </Component>
    )
  }
)
